module.exports = __webpack_public_path__ + "img/percentage-return.ea5a3fa0.png";